import actionCreators from '../../../redux/action_creators';

export default (err, { body: comment }) => {
  const { store } = window.reduxState;

  store.dispatch(actionCreators.addOverviewComment(comment));
};
